import Button from "@mui/material/Button";
interface GButtonProps {
  text: string;
  color?: string;
  icon?: React.ReactNode;
  type?: boolean;
  disabled?: boolean;
  backgroundColor?: string;
  width?: number;
  handleAction?: () => void;
}
function GButtonContained(props: GButtonProps) {
  return (
    <Button
      variant="contained"
      disabled={props.disabled}
      sx={{
        backgroundColor: "#46B6E7",
        "&:hover": {
          backgroundColor: "#0AA3E4",
        },
        borderRadius: 60,
        minWidth: props.width ? props.width : 234,
        fontSize: 18,
      }}
      onClick={() => {
        props.handleAction && props.handleAction();
      }}
      endIcon={props.icon && props.icon}
      type={props.type ? "submit" : undefined}
    >
      {props.text}
    </Button>
  );
}

export default GButtonContained;
